/**
 * JackpotEditPage — Host for the edit flow of an existing jackpot.
 *
 * Delegates all UI and state wiring to the shared <JackpotWizard />, matching
 * the way <RodeoWizard /> serves both create and edit paths. The previous
 * custom "Jackpot Information + Events" form has been retired so delegates
 * get the same wizard experience as create.
 */

import { useParams, useNavigate } from 'react-router-dom';
import { JackpotWizard } from '@/components/delegate/JackpotWizard';

export default function JackpotEditPage() {
  const { jackpotId } = useParams<{ jackpotId: string }>();
  const navigate = useNavigate();

  const handleClose = () => navigate('/delegate/jackpots');

  return <JackpotWizard jackpotId={jackpotId ?? null} onClose={handleClose} />;
}
